import './LiveVoting.scss';

import React, {useCallback, useEffect, useState} from 'react';

import AlreadyVoted from './AlreadyVotedScreen/AlreadyVoted';
import InfoScreen from './QuestionTypes/InfoScreen/InfoScreen';
import MultipleChoiceQuestion from './QuestionTypes/MultipleChoiceQuestionScreen/MultipleChoiceQuestion';
import PlsWait from './PlsWaitScreen/PlsWait';
import ShowResults from './ShowResults/ShowResults';
import TextAnswer from './QuestionTypes/TextAnswer/TextAnswer';
import VotingStopped from './VotingStopped/VotingStopped';

const ScreenSelection = props => {
    const {question, answers = {}, onVote, votingEnabled, resultsVisible} = props,
        [answerAgain, setAnswerAgain] = useState(false);

    useEffect(() => {
        setAnswerAgain(false);
    }, [question, votingEnabled]);

    const handleAnswerAgain = useCallback(() => setAnswerAgain(true), []),
        handleCancelAnswerAgain = useCallback(() => setAnswerAgain(false), []),
        handleVote = useCallback(
            (optionId, optionValue) => {
                setAnswerAgain(false);
                onVote(optionId, optionValue);
            },
            [onVote]
        );

    if (answers[question.id] && !answerAgain) {
        if (resultsVisible) {
            return <ShowResults {...props} onAnswerAgain={handleAnswerAgain} />;
        } else {
            return <AlreadyVoted {...props} onAnswerAgain={handleAnswerAgain} />;
        }
    } else if (!votingEnabled) {
        if (resultsVisible) {
            return <ShowResults {...props} />;
        } else {
            return <VotingStopped {...props} />;
        }
    }

    switch (question.type || question.answer_type) {
        case 'infoscreen':
            return <InfoScreen {...props} />;
        case 'options':
            return <MultipleChoiceQuestion {...props} />;
        case 'text':
            return <TextAnswer {...props} answerAgain={answerAgain} onVote={handleVote} onCancelAnswerAgain={handleCancelAnswerAgain} />;
    }

    return <PlsWait {...props} />;
};

export default ScreenSelection;
